
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { IRouteMeta } from "@/router/interface";
import program_routes from "@/api/routes/programs";

import { normalizedProgramVersionStatusBadgeColor } from "@/helpers";

import { IProgram } from "@/models/program/program";

@Component({
  name: "CProgramListStructure"
})
export default class CProgramListStructure extends Vue {
  @Prop({ required: true }) factory_id!: string;
  @Prop({ required: true }) infinity_id!: string | null;

  public normalizedProgramVersionStatusBadgeColor = normalizedProgramVersionStatusBadgeColor;

  public preload: boolean = false;

  public programs: IProgram[] = [];

  protected async created() {
    await this.loadPrograms();
  }

  @Watch("factory_id")
  @Watch("infinity_id")
  protected async changeStructure() {
    if (this.factory_id && !this.infinity_id) {
      await this.loadPrograms();
    }
  }

  private async loadPrograms() {
    this.preload = true;

    return this.$api
      .get(program_routes.index_list, {
        params: {
          factory_id: this.factory_id,
          infinity_id: this.infinity_id,
          section_id: (this.$router.currentRoute.meta! as IRouteMeta)
            .permissions?.[0]
        }
      })
      .then(({ data: res }: { data: IProgram[] }) => {
        this.programs = res;
      })
      .finally(() => {
        this.preload = true;
      });
  }
}
